import React from "react";
import "./Vision.css"

function Vision() {
  return (
    <div className="page-hero" style={{ backgroundImage: "url('/images/sihsbuilding.jpg')" }}>
      <div className="overlay">
        <h1>Our Vision &amp; Mission</h1>
      </div>
    </div>
  );
}

export default Vision;
